import React from 'react';
import { Link } from 'react-router-dom';
import { trackLinkClick } from '../lib/analytics';
import BRAND from '../config/brand';
import './PublicLinksPage.css';

export default function ThankYouPage() {
  return (
    <div className="public-linktree-page public-service-page">
      <main className="public-linktree-shell public-service-shell public-lead-shell">
        <section className="public-service-panel public-lead-card public-lead-success">
          <Link className="public-service-logo" to="/links" aria-label="Back to planning links">
            <img src={BRAND.logoSrc} alt="Bautista Planning and Analytics" />
          </Link>
          <h1>Your Goal-Setting Meeting is booked.</h1>
          <p>Watch for the confirmation email with the meeting details. Before we meet, you can also explore the calculators or reply to the confirmation if there is anything specific you want to cover.</p>
          <div className="public-service-actions public-service-actions--centered">
            <Link
              className="public-service-cta public-service-cta--primary"
              to="/calculators"
              onClick={() => trackLinkClick('/calculators', 'Explore Planning Calculators', {
                destination_type: 'internal',
                button_id: 'thank_you_explore_calculators',
                button_label: 'Explore Planning Calculators',
              })}
            >
              Explore Planning Calculators
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}
